import {defineRouting} from "next-intl/routing";

export const routing = defineRouting({
  locales: ["el", "en"],
  defaultLocale: "el",
  localePrefix: "always",
  localeDetection: false,
  localeCookie: true,
  pathnames: {
    "/": "/",
    "/login": "/login",
    "/forgot-password": "/forgot-password",
    "/incidents": "/incidents",
    "/master-networks": "/master-networks",
    "/network-reports": "/network-reports",
    "/network-reports/transactions": "/network-reports/transactions",
    "/network-reports/incidents": "/network-reports/incidents",
    "/network-reports/ratings": "/network-reports/transactions",
    "/ratings": "/ratings",
    "/reroute": "/reroute",
    "/reroute/app-performance": "/reroute/app-performance",
    "/reroute/operational-performance": "/reroute/operational-performance",
    "/shop-cleverpoint": "/shop-cleverpoint",
    "/store-reports": "/store-reports",
    "/transaction-overview": "transaction-overview",
    "/transaction-overview/reroute": "transaction-overview/reroute",
    "/transaction-overview/deliveries": "/transaction-overview/deliveries",
    "/transaction-overview/failed-deliveries": "/transaction-overview/failed-deliveries",
    "/transaction-overview/prerouting": "/transaction-overview/prerouting",
    "/transaction-overview/returns": "/transaction-overview/returns",
    "/transaction-overview/shipments": "/transaction-overview/shipments",
    "/transaction-overview/transactions": "/transaction-overview/transactions",
    "/transaction-overview/activity": "/transaction-overview/activity",
  },
});
